import { publicImages } from '@utils/shared'
import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  scrollWrapper: {
    gap: '24px',
    paddingBlock: 1.5,
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
